import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { TimelogConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ThsService } from './api/ths.service';
import { TimelogService } from './api/timelog.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class TimelogApiModule {
    public static forRoot(configurationFactory: () => TimelogConfiguration): ModuleWithProviders<TimelogApiModule> {
        return {
            ngModule: TimelogApiModule,
            providers: [ { provide: TimelogConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: TimelogApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('TimelogApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
